import React from 'react'

import coding_data from "./Coding.Data"
import CodingCard from "./CodingCard"

const Coding = () => {
    return (
        <div className="col col-d-6 col-t-6 col-m-12 border-line-v">
            <div className="skills-list circles">
                <div className="skill-title border-line-h">
                    <div className="icon"><i className="fa fa-code"></i></div>
                    <div className="name">Coding</div>
                </div>
                <ul>
                    {
                        coding_data.map(codeData =>
                            <CodingCard codeData={codeData} />
                        )
                    }
                </ul>
            </div>
        </div>
    );
}

export default Coding;